module.exports = __webpack_public_path__ + "static/media/cxj_banner_three.f402f137.png";